import React from 'react';
import { TableRow } from '@mui/material';
import { FormAutocomplete } from '~/components/FormComponents/FormAutocomplete.tsx';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { FinancialConditionTableCell } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTableCell.tsx';
import { FinancialConditionTableDeleteCell } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTableDeleteCell.tsx';
import type { ICurrencyExchangeRowProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/currencyExchanges/types.ts';
import {
  filterBankOptions,
  normalizeDecimalValue,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';

export const CurrencyExchangeRow: React.FC<ICurrencyExchangeRowProps> = ({
  index,
  canRemove,
  disabled,
  bankOptions,
  currencyOptions,
  isBanksLoading,
  isCurrenciesLoading,
  onRemove,
}) => (
  <TableRow>
    <FinancialConditionTableCell>
      <FormAutocomplete
        name={`currencyExchanges.${index}.bank`}
        label="Банк"
        options={bankOptions}
        loading={isBanksLoading}
        filterOptions={filterBankOptions}
        shouldSaveLabel
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormAutocomplete
        name={`currencyExchanges.${index}.soldCurrency`}
        label="Продана валюта"
        options={currencyOptions}
        preserveOptionsOrder
        loading={isCurrenciesLoading}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`currencyExchanges.${index}.soldAmount`}
        label="Сума продажу"
        type="text"
        inputProps={{ inputMode: 'decimal' }}
        normalizeOnBlur={normalizeDecimalValue}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormAutocomplete
        name={`currencyExchanges.${index}.boughtCurrency`}
        label="Куплена валюта"
        options={currencyOptions}
        preserveOptionsOrder
        loading={isCurrenciesLoading}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`currencyExchanges.${index}.boughtAmount`}
        label="Сума купівлі"
        type="text"
        inputProps={{ inputMode: 'decimal' }}
        normalizeOnBlur={normalizeDecimalValue}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableDeleteCell
      label={`Видалити операцію ${index + 1}`}
      disabled={disabled}
      hidden={!canRemove}
      onDelete={onRemove}
    />
  </TableRow>
);
